import { Box, Card, CardActionArea, makeStyles } from '@material-ui/core';
import Typography from '../../../components/overrides/Typography';
import { useShortVenueDetails } from '../../../utils/useShortVenueDetails';
import { ReactComponent as SignatureIcon } from '../../../assets/icons/grv-benefits-small.svg';
import mediaImg from '../../../assets/images/media.png';
import React from 'react';
import useCustomIntersectionObserver from '../../../utils/useCustomIntersectionObserver';
import { trackPageImpression } from '../../../utils/useOneTag';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2.5, 0),
    '& .MuiButtonBase-root': {
      borderRadius: theme.spacing(0.5),
      justifyContent: 'flex-start',
    },
  },
  cardActionArea: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
  image: {
    width: theme.spacing(11),
    height: theme.spacing(11),
    borderRadius: theme.spacing(0.5),
    objectFit: 'cover',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  descriptionBox: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  signatureIcon: {
    marginLeft: theme.spacing(1),
  },
}));

export const RestaurantCard = ({
  venue,
  onClick,
  shouldShowCityInDescription,
}) => {
  const classes = useStyles();
  const { getShortVenueDescription, getShortDescriptionForRegularVenue } =
    useShortVenueDetails();
  const description = shouldShowCityInDescription
    ? getShortDescriptionForRegularVenue(venue, venue.market?.name)
    : getShortVenueDescription(venue);

  const elementRef = useCustomIntersectionObserver(
    () => {
      trackPageImpression('no-results', 'no-results-card', venue.name);
    },
    { threshold: 0.8, triggerOnce: false }
  );

  return (
    <Card className={classes.card} elevation={0} ref={elementRef}>
      <CardActionArea className={classes.cardActionArea} onClick={onClick}>
        <img
          src={venue.images?.[0] || mediaImg}
          alt={`${venue.name}`}
          className={classes.image}
          onError={(e) => (e.target.src = mediaImg)} // Fallback image
        />
        <Box className={classes.details}>
          <Typography variant="medium1Normal">{venue.name}</Typography>
          <Box className={classes.descriptionBox}>
            <Typography variant="small2Normal">
              {description}
              <SignatureIcon className={classes.signatureIcon} />
            </Typography>
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
};
